import { LoadingButton } from "@mui/lab";
import { Alert, Box, Grid, TextField } from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { useFormik } from "formik";
import moment from "moment";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";

import {
  updateCustomerThunk,
  createCustomerProfileThunk,
} from "store/reducers/user_profiles/customerSlice";
import * as yup from "yup";

const validation = yup.object({
  first_name: yup.string().required(),
  last_name: yup.string(),
  employee_id: yup.string(),
  secondary_phone: yup.string(),
  address: yup.string(),
  location: yup.string(),
  biometric: yup.string(),
  aadhaar: yup.string(),
  rfid: yup.string(),
  dob: yup.string(),
});
const CreateCustomer = ({ customer }) => {
  const formik = useFormik({
    initialValues: {
      first_name: customer?.first_name ?? "",
      last_name: customer?.last_name ?? "",
      employee_id: customer?.employee_id ?? "",
      secondary_phone: customer?.secondary_phone ?? "",
      address: customer?.address ?? "",
      location: customer?.location ?? "",
      biometric: customer?.biometric ?? "",
      aadhaar: customer?.aadhaar ?? "",
      rfid: customer?.rfid ?? "",
      dob: customer?.dob ?? moment().format("YYYY-MM-DD"),
    },
    validationSchema: validation,

    onSubmit: (data) => {
      const _customer = {
        ...data,
        secondary_phone:
          data.secondary_phone.trim().length === 0
            ? null
            : data.secondary_phone,
      };
      console.log(_customer);
      if (customer) {
        dispatch(updateCustomerThunk({ id: customer.id, data: _customer }));
      } else {
        dispatch(createCustomerProfileThunk(_customer));
      }
    },

    validateOnChange: false,
  });
  const { status } = useSelector((state) => state.customers);

  useEffect(() => {
    console.log(formik.errors);
  }, [formik.errors]);
  useEffect(() => {
    if (status?.error === "create" || status?.error === "update") {
      // console.log(status?.errorMessage);
      Object.keys(status?.errorMessage).forEach((key) => {
        // console.log(key, status?.errorMessage[key][0]);
        formik.setFieldError(key, status?.errorMessage[key][0]);
      });
    }
  }, [status]);
  return (
    <Box marginTop={2}>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1.5} paddingY={1}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="First name"
              variant="outlined"
              name="first_name"
              fullWidth
              value={formik.values.first_name}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.first_name)}
              helperText={formik.errors.first_name}
              autoComplete="new-password"
              type="text"
              required
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Last name"
              variant="outlined"
              name="last_name"
              fullWidth
              value={formik.values.last_name}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.last_name)}
              helperText={formik.errors.last_name}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Employee id"
              variant="outlined"
              name="employee_id"
              fullWidth
              value={formik.values.employee_id}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.employee_id)}
              helperText={formik.errors.employee_id}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="Phone"
              variant="outlined"
              name="secondary_phone"
              fullWidth
              value={formik.values.secondary_phone}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.secondary_phone)}
              helperText={formik.errors.secondary_phone}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="address"
              variant="outlined"
              name="address"
              fullWidth
              value={formik.values.address}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.address)}
              helperText={formik.errors.address}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="location"
              variant="outlined"
              name="location"
              fullWidth
              value={formik.values.location}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.location)}
              helperText={formik.errors.location}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="biometric"
              variant="outlined"
              name="biometric"
              fullWidth
              value={formik.values.biometric}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.biometric)}
              helperText={formik.errors.biometric}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="aadhaar"
              variant="outlined"
              name="aadhaar"
              fullWidth
              value={formik.values.aadhaar}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.aadhaar)}
              helperText={formik.errors.aadhaar}
              autoComplete="new-password"
              type="text"
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              label="rfid"
              variant="outlined"
              name="rfid"
              fullWidth
              value={formik.values.rfid}
              onChange={formik.handleChange}
              error={Boolean(formik.errors.rfid)}
              helperText={formik.errors.rfid}
              autoComplete="new-password"
              type="text"
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <DesktopDatePicker
                label="Offer from date"
                inputFormat="YYYY-MM-DD"
                name="offer_from_date"
                value={formik.values.offer_from_date}
                onChange={(value) =>
                  formik.setFieldValue(
                    "offer_from_date",
                    value.format("YYYY-MM-DD"),
                    true
                  )
                }
                renderInput={(params) => (
                  <TextField fullWidth variant="outlined" {...params} />
                )}
              />
            </LocalizationProvider>
          </Grid>
        </Grid>
        {(status?.error === "create" || status?.error === "update") && (
          <Alert sx={{ my: 1 }} severity="error">
            Error occurred
          </Alert>
        )}

        {(status?.success === "create" || status?.success === "update") && (
          <Alert sx={{ my: 1 }} severity="success">
            Success
          </Alert>
        )}

        <LoadingButton
          variant="contained"
          type="submit"
          sx={{ paddingX: 10, marginTop: 1 }}
          loading={status?.loading === "create" || status?.loading === "update"}
        >
          {customer ? "Update" : "Add"}
        </LoadingButton>
      </form>
    </Box>
  );
};

export default CreateCustomer;
